import React from "react";
import ReactDOM from "react-dom";
import App from "./App";

export function disableConsoleInDev() {
    const env = process.env.REACT_APP_ENV;
    console.log("Console_debug_status : ", env); // Check this appears once
    if (env === 'production') {
      console.log = function () {};
      console.warn = function () {};
      console.error = function () {};
      console.info = function () {};
    }
  }
  disableConsoleInDev();
ReactDOM.render(
  <React.StrictMode>
    <App />
    
  </React.StrictMode>,
  document.getElementById("root")
);
